import { render, staticRenderFns } from "./assurance_list.vue?vue&type=template&id=5f017419&"
import script from "./assurance_list.vue?vue&type=script&lang=js&"
export * from "./assurance_list.vue?vue&type=script&lang=js&"
import style0 from "./assurance_list.vue?vue&type=style&index=0&id=5f017419&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports